import { render, staticRenderFns } from "./NewPromotionBaseSettingsHall.vue?vue&type=template&id=0785a529&"
import script from "./NewPromotionBaseSettingsHall.vue?vue&type=script&lang=js&"
export * from "./NewPromotionBaseSettingsHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports